import { useQuery, UseQueryOptions } from '@tanstack/react-query';

// helpers
import { BaseError } from '../../helpers/BaseError';

import useGetCurrentMessageContent from '../../hooks/message-content/useGetCurrentMessageContent';

// models
import { GenericMessagePreviewModel } from '../../models/editor.model';
import { TestMessageFilter } from 'models/message-content.model';

// services
import API from '../../services/api';

import formulaKeys from './_queryKeys';

const generateMessagesV1 = async (
    formulaId: number,
    messageContentId?: string,
    preview_count?: number,
    filters?: TestMessageFilter,
): Promise<GenericMessagePreviewModel[]> => {
    const params: Record<string, string | number> = {};
    if (messageContentId) {
        params.message_content_id = messageContentId;
    }
    if (preview_count) {
        params.preview_count = preview_count;
    }
    const { data } = await API.generateMessagesV1(formulaId, filters, params);

    return data;
};

export default function useMessageGenerationQueryV1(
    formulaId: number,
    messageContentId?: string,
    preview_count?: number,
    filters?: TestMessageFilter,
    options?: Partial<UseQueryOptions<any, BaseError>>,
) {
    const { currentMessageContentId: hookMessageContentId } =
        useGetCurrentMessageContent(formulaId);
    const currentMessageContentId = messageContentId || hookMessageContentId;
    return useQuery<GenericMessagePreviewModel[], BaseError>({
        queryKey: formulaKeys.formulaMessages(
            formulaId,
            currentMessageContentId,
            preview_count,
            filters,
        ),
        queryFn: () =>
            generateMessagesV1(
                formulaId,
                currentMessageContentId,
                preview_count,
                filters,
            ),
        retry: false,
        enabled: !!formulaId,
        ...options,
    });
}
